import { Controller } from "@hotwired/stimulus";
import animateCSS from "../utils/animateCSS";

export default class extends Controller<HTMLDivElement> {
  close() {
    this.element.style.overflowY = "hidden";

    animateCSS(this.element, "fadeOut").then(() => {
      this.element.style.transitionProperty =
        "height, margin, padding, border, opacity";
      this.element.style.transitionDuration = "200ms";
      this.element.style.transitionTimingFunction = "linear";

      this.element.style.opacity = "0";
      this.element.style.height = "0";
      this.element.style.marginTop = "0";
      this.element.style.marginBottom = "0";
      this.element.style.paddingTop = "0";
      this.element.style.paddingBottom = "0";
      this.element.style.border = "0";
    });

    this.element.addEventListener(
      "transitionend",
      () => {
        if (this.element.parentNode) {
          this.element.parentNode.removeChild(this.element);
        }
      },
      { once: true }
    );
  }
}
